import { Component, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { IdleService } from './core/services/idle.service';
import { filter } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'RealWorld.fi - Management application';
    idleWarningTime = 0;
    confirmationData = '';
    @ViewChild('sessionExpiryModal') sessionExpiryModal: { show: () => void; hide: () => void; };
    constructor(
        private router: Router,
        private idle: Idle,
        private idleService: IdleService,
        private titleService: Title,
        private destroyRef: DestroyRef
    ) {
        this.idle.onIdleStart.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.sessionExpiryModal?.show();
        });
    }

    /**
     * loaded on initialization
     */
    ngOnInit(): void {
        this.idleService.reset();
        this.router.events
        .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
        .subscribe((event: any) => {
          this.setTitleBasedOnRoute(event.urlAfterRedirects);
        });
        this.idle.onTimeoutWarning.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((countdown) => {
            this.idleWarningTime = countdown;
            this.confirmationData =
                `Your session is going to expire in ${this.idleWarningTime} ${this.idleWarningTime > 1 ? 'seconds' : 'second'}.`
        })
        this.idle.onIdleEnd.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.sessionExpiryModal.hide()
        });

        /** called after the inactive timeout */
        this.idle.onTimeout.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.sessionExpiryModal.hide()
            this.idleService.logout();

        });

    }

    private setTitleBasedOnRoute(route: string) {
        const titles: { [key: string]: string } = {
          '/manage-user': 'Manage Users - All Users',
          '/dashboard': 'Management - Dashboard',
          '/announcement-detail': 'Management - Announcement',
          '/manage-delivery/delivery-history': 'Management - Delivery History',
          '/manage-delivery': 'Management - Manage Delivery',
          '/manage-category': 'Management - Manage Categories',
          '/manage-collection': 'Management - Manage Collections',
          '/manage-nft': 'Management - Manage Assets',
          '/manage-nft/burn-nft': 'Management - Burn Asset',
          '/manage-user/blocked-user': 'Manage Users - Blocked Users',
          '/royalty': 'Management - Royalty Release'
        };
    
        const defaultTitle = 'RealWorld.fi - Management Application';
        this.titleService.setTitle(titles[route] || defaultTitle);
      }
}
